import { render, staticRenderFns } from "./TaxRateTable.vue?vue&type=template&id=07f06b4a"
import script from "./TaxRateTable.vue?vue&type=script&lang=js"
export * from "./TaxRateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports